import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
} from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { ACQUISITION_CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexExperientialMGM.scss';

const AmexExperientialMGM = (
  {
    baseRequestUrl,
    mgmConfig: {
      title,
      subtitle,
      text,
      refer_a_friend_image: referLogo,
      card_left_image: cardLeftImg,
      card_center_image: cardCenterImg,
      card_right_image: cardRightImg,
      cta: {
        label,
        url,
      },

    },
    Analytics,
  }
) => {
  const sanitizedTitle = sanitizeString(title);
  const sanitizedSubtitle = sanitizeString(subtitle);
  const sanitizedText = sanitizeString(text);

  return (
    <div className="AmexExperientialMGM">
      <div className="container">
        <div className="AmexExperientialMGM__wrapper">
          <img
            src={`${baseRequestUrl}Experiential/images/${referLogo}`}
            className="AmexExperientialMGM__logo"
            alt="Refer a friend logo"
          />
          <h2
            className="AmexExperientialMGM__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedTitle,
            }}
          />
          <div className="AmexExperientialMGM__cards">
            <div className="AmexExperientialMGM__card">
              <img
                src={`${baseRequestUrl}Experiential/images/${cardLeftImg}`}
                className="AmexExperientialMGM__card-img"
                alt=""
              />
            </div>
            <div className="AmexExperientialMGM__card">
              <img
                src={`${baseRequestUrl}Experiential/images/${cardCenterImg}`}
                className="AmexExperientialMGM__card-img"
                alt=""
              />
            </div>
            <div className="AmexExperientialMGM__card">
              <img
                src={`${baseRequestUrl}Experiential/images/${cardRightImg}`}
                className="AmexExperientialMGM__card-img"
                alt=""
              />
            </div>
          </div>
          <h3
            className="AmexExperientialMGM__subtitle"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedSubtitle,
            }}
          />
          <p
            className="AmexExperientialMGM__text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedText,
            }}
          />
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={url}
            className="AmexExperientialMGM__cta"
            onClick={() => {
              const extraParam = {
                action_name: 'MGM - Click',
              };
              handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, extraParam);
            }}
          >
            {label}
          </Link>
        </div>
      </div>
    </div>
  );
};

AmexExperientialMGM.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  mgmConfig: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    refer_a_friend_image: PropTypes.string,
    card_left_image: PropTypes.string,
    card_center_image: PropTypes.string,
    card_right_image: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    }),
  }).isRequired,
};

export default AmexExperientialMGM;
